module.exports = __webpack_public_path__ + "img/ms.be0d2568.svg";